var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"previewJobHeader"},[_vm._v(" Job "),_c('router-link',{staticClass:"link",attrs:{"to":`/job/${_vm.jobId}`}},[_vm._v("#"+_vm._s(_vm.jobId))]),(_vm.jobDate)?[_vm._v(", "+_vm._s(_vm.jobDate))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }